<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M35 20H37H39V22V26V28V36V38H37H19H17V36V28V26V22V20H19H21V18H23V20V22H21H19V26H37V22H35H33V20V18H35V20ZM19 36H37V28H19V36ZM25 20H31V22H25V20Z" fill="currentColor"/>
</svg>
